import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mapIndexToLetter',
  standalone: true,
})
export class MapIndexToLetterPipe implements PipeTransform {
  transform(index: number | undefined): string {
    if (index == null || index < 1) {
      return '';
    }

    let result = '';
    while (index > 0) {
      index--; // adjust for 0-indexing
      const remainder = index % 26;
      result = String.fromCharCode(97 + remainder) + result;
      index = Math.floor(index / 26);
    }

    return result;
  }
}
